let Language;

Language = {
  sum: "Qual é o resultado da soma ?",
  sub: "Qual é o resultado da subtração ?"
};

export default Language;
